<!-- Main RFQ Container -->
<div class="rfq-container">
    <div class="rfq-header-container" *ngIf="!showEditPartSection">
        <h3>{{rfqDetails?.rfqName}}</h3>
        <a href="javascript:void(0)" (click)="goBackToRfqDetails()">Back to RFQ Details</a>
    </div>
    <!-- RFQ Parts Section -->
    <div class="parts-section">
        <!-- Parts List - Only show when files are uploaded -->
        <div class="parts-list" *ngIf="showEditPartSection">
            <!-- Part Details Modal -->

            <div class="modal-body-container">
                <!-- Add Part Button - Only show when no files are uploaded -->
                <div class="add-part-button" *ngIf="!hasUploadedFiles">
                    <button type="button" class="btn-add-part" data-bs-toggle="modal" data-bs-target="#addPartModal">
                        <span class="plus-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M16 4C16.5523 4 17 4.44772 17 5V15H27C27.5523 15 28 15.4477 28 16C28 16.5523 27.5523 17 27 17H17V27C17 27.5523 16.5523 28 16 28C15.4477 28 15 27.5523 15 27V17H5C4.44772 17 4 16.5523 4 16C4 15.4477 4.44772 15 5 15H15V5C15 4.44772 15.4477 4 16 4Z"
                                    fill="white" />
                            </svg>
                        </span>
                        <span>Add a part to your RFQ</span>
                    </button>
                </div>
                <div class="modal-header">
                    <button class="close-btn" (click)="patchPartData()">
                        <img src="assets/img/svg/close-x-lg.svg" alt="Close">
                    </button>
                </div>
                <div class="modal-columns">

                    <!-- Left Column - Added Files -->
                    <div class="modal-column" [formGroup]="partForm">
                        <h3>Added Files</h3>
                        <div class="file-section">
                            <h4>3D Model File(s):</h4>
                            <div *ngIf="modelFiles.length === 0" class="no-file-message">No file added</div>
                            <div *ngFor="let file of modelFiles; let i = index" class="file-item">
                                <span>{{ formatFileName(file.name) }}</span>
                                <button *ngIf="modelFiles.length > 1" class="delete-btn" (click)="removeModelFile(i)">
                                    <img src="assets/img/svg/delete-icon.svg" alt="Delete">
                                </button>
                            </div>
                        </div>
                        <div class="file-section">
                            <h4>2D Drawing File(s):</h4>
                            <div *ngIf="drawingFiles.length === 0" class="no-file-message">No file added</div>
                            <div *ngFor="let file of drawingFiles; let i = index" class="file-item">
                                <span>{{ formatFileName(file.name) }}</span>
                                <button class="delete-btn" *ngIf="drawingFiles.length > 1"
                                    (click)="removeDrawingFile(i)">
                                    <img src="assets/img/svg/delete-icon.svg" alt="Delete">
                                </button>
                            </div>
                        </div>
                        <div class="file-section">
                            <h4 class="mb-0">Supporting File(s):</h4>
                            <p>Upload any additional, supporting files for your part</p>
                            <input type="file" #supportingFileInput style="display: none"
                                (change)="onSupportingFileSelected($event)" multiple />
                            <button class="upload-btn" (click)="supportingFileInput.click()">+ Click to upload</button>
                            <div *ngIf="supportingFiles.length > 0" class="uploaded-files">
                                <div *ngFor="let file of supportingFiles; let i = index" class="file-item">
                                    <span>{{ formatFileName(file.name) }}</span>
                                    <button class="delete-btn" (click)="removeSupportingFile(i)">
                                        <img src="assets/img/svg/delete-icon.svg" alt="Delete">
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="notes-section">
                            <h4>Notes</h4>
                            <textarea formControlName="notes"
                                placeholder="Add any notes or additional information regarding your RFQ here."></textarea>
                        </div>
                    </div>

                    <!-- Right Column - Part Details -->
                    <div class="modal-column" [formGroup]="partForm">
                        <h3>Part Details</h3>

                        <div class="form-group">
                            <div class="w-100">
                                <label
                                    [ngClass]="{'label-invalid': (partForm.get('partName')?.touched || submitted) && partForm.get('partName')?.invalid}">
                                    Part Name<sup class="required">*</sup>
                                </label>
                                <input type="text" id="partName" class="form-control" formControlName="partName"
                                    [ngClass]="{'input-invalid': (partForm.get('partName')?.touched || submitted) && partForm.get('partName')?.invalid}">
                            </div>
                            <div class="w-100">
                                <label
                                    [ngClass]="{'label-invalid': (partForm.get('partNumber')?.touched || submitted) && partForm.get('partNumber')?.invalid}">
                                    Part Number<sup class="required">*</sup>
                                </label>
                                <input type="text" id="partNumber" class="form-control" formControlName="partNumber"
                                    [ngClass]="{'input-invalid': (partForm.get('partNumber')?.touched || submitted) && partForm.get('partNumber')?.invalid}">
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="w-100">
                                <label
                                    [ngClass]="{'label-invalid': (partForm.get('quantity')?.touched || submitted) && partForm.get('quantity')?.invalid}">
                                    Quantity
                                </label>
                                <input type="number" id="quantity" class="form-control" formControlName="quantity"
                                    [ngClass]="{'input-invalid': (partForm.get('quantity')?.touched || submitted) && partForm.get('quantity')?.invalid}">
                            </div>
                        </div>
                        <div class="mat-specs-container">
                            <h4>Material Specifications<sup class="required">*</sup></h4>
                            <div class="form-group-container">
                                <p-select id="material" formControlName="material" [options]="materialList"
                                    optionLabel="label" optionValue="label" placeholder="Select Material"
                                    styleClass="w-full"
                                    [ngClass]="{'input-invalid': (partForm.get('material')?.touched || submitted) && partForm.get('material')?.invalid}">
                                </p-select>
                                <input type="text" id="materialGrade" formControlName="materialGrade"
                                    class="form-control mt-2"
                                    placeholder="Add grade (e.g., 6160T6, 4140, 316/316L, etc.)">
                            </div>

                            <div class="form-group-container finishes-container">
                                <h4 class="mb-0"
                                    [ngClass]="{'label-invalid': (partForm.get('finishes')?.touched || submitted) && partForm.get('finishes')?.invalid}">
                                    Finish
                                </h4>
                                <p class="hint">Select at least one finish for this part.</p>
                                <div class="finish-multi-select">
                                    <p-multiSelect formControlName="finishes" [options]="postProductionList"
                                        optionLabel="label" optionValue="label" [filter]="false" [showToggleAll]="false"
                                        [panelStyle]="{minWidth:'12rem'}" styleClass="w-full custom-inspection-select custom-finish-select"
                                        [maxSelectedLabels]="2" placeholder="Select Finish" />
                                </div>
                            </div>

                            <div class="form-group-container">
                                <h4>Tolerance<sup class="required">*</sup></h4>
                                <div class="tolerance-options">
                                    <div class="custom-checkbox">
                                        <input type="radio" id="standard" formControlName="tolerance"
                                            [value]="STANDARD_TOLERANCE">
                                        <label for="standard">{{ STANDARD_TOLERANCE }}</label>
                                    </div>
                                    <div class="custom-checkbox">
                                        <input type="radio" id="custom" formControlName="tolerance" value="custom">
                                        <label for="custom">Custom</label>
                                    </div>
                                </div>

                                <p-select *ngIf="partForm.get('tolerance')?.value === 'custom'" id="customTolerance"
                                    formControlName="customTolerance" [options]="toleranceList" optionLabel="label"
                                    optionValue="label" placeholder="Select Custom Tolerance" styleClass="w-full"
                                    class="custom-tolerance-select"
                                    [ngClass]="{'input-invalid': (partForm.get('customTolerance')?.touched || submitted) && partForm.get('customTolerance')?.invalid}">
                                </p-select>

                                <div class="error-message" *ngIf="isFieldInvalid('tolerance')">
                                    {{ getErrorMessage('tolerance') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-container">
                <button class="btn-add-to-quote" (click)="onContinueToSummary()">Add Part to RFQ</button>
            </div>
        </div>

        <!-- Part Added to RFQ - Only show when files are uploaded -->
        <div class="part-card" *ngIf="partDetailList.length > 0 && !showEditPartSection">
            <div class="part-image">
                <div class="image-placeholder">
                    <!-- <img [src]="(drawingFiles && drawingFiles.length > 0 && drawingFiles[0].preview) ? drawingFiles[0].preview : 'assets/img/part-image.png'" alt="Part Image"> -->
                    <img src="assets/img/part-image.png" alt="Part Image">
                </div>
                <div class="part-title">
                    <strong>{{ partForm.get('partName')?.value || 'Part Name' }}</strong><br />
                    <small>{{ partForm.get('partNumber')?.value || 'Part Number' }}</small>
                </div>
            </div>
            <div class="part-details">
                <div>
                    <div class="part-detail-item"><strong>Quantity</strong> <span class="text-truncate">{{
                            partForm.get('quantity')?.value || 'Quantity' }}</span></div>
                    <div class="part-detail-item"><strong>Material</strong> <span class="text-truncate">{{
                            partForm.get('material')?.value || 'Material' }}</span></div>
                    <div class="part-detail-item"><strong>Grade</strong> <span class="text-truncate">{{
                            partForm.get('materialGrade')?.value || '-' }}</span></div>
                </div>
            </div>
            <div class="part-details custom-part-details">
                <div>
                    <div class="part-detail-item"><strong>Finish</strong> <span class="text-truncate">{{
                            (partForm.get('finishes')?.value)?.join(', ') || '-' }}</span></div>
                    <div class="part-detail-item"><strong>Tolerance</strong>
                        <span class="text-truncate">
                            {{ partForm.get('tolerance')?.value === 'custom'
                            ? partForm.get('customTolerance')?.value
                            : partForm.get('tolerance')?.value }}
                        </span>
                    </div>

                    <div class="drawing-model-files">
                        <div class="file-label" [class.attached]="modelFiles.length > 0">
                            <strong>Model File</strong>
                            <span *ngIf="modelFiles.length > 0" class="file-check">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
                                    fill="none">
                                    <path
                                        d="M9.55237 2.97725C9.76915 2.75758 10.1206 2.75758 10.3374 2.97725C10.5515 3.19423 10.5542 3.54436 10.3453 3.7646L5.91018 9.0073C5.90592 9.0127 5.90136 9.01786 5.89654 9.02275C5.67975 9.24242 5.32828 9.24242 5.11149 9.02275L2.41259 6.28791C2.1958 6.06824 2.1958 5.71209 2.41259 5.49242C2.62937 5.27275 2.98085 5.27275 3.19763 5.49242L5.48729 7.81256L9.53764 2.99408C9.54222 2.98818 9.54713 2.98256 9.55237 2.97725Z"
                                        fill="#0A0F15" />
                                </svg>
                            </span>
                            <span *ngIf="modelFiles.length === 0" class="file-x">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9"
                                    fill="none">
                                    <path
                                        d="M1.20738 1.60512C1.09754 1.49529 1.09754 1.31721 1.20738 1.20738C1.31721 1.09754 1.49529 1.09754 1.60512 1.20738L4.5 4.10225L7.39488 1.20738C7.50471 1.09754 7.68279 1.09754 7.79262 1.20738C7.90246 1.31721 7.90246 1.49529 7.79262 1.60512L4.89775 4.5L7.79262 7.39488C7.90246 7.50471 7.90246 7.68279 7.79262 7.79262C7.68279 7.90246 7.50471 7.90246 7.39488 7.79262L4.5 4.89775L1.60512 7.79262C1.49529 7.90246 1.31721 7.90246 1.20738 7.79262C1.09754 7.68279 1.09754 7.50471 1.20738 7.39488L4.10225 4.5L1.20738 1.60512Z"
                                        fill="#0A0F15" stroke="#0A0F15" stroke-width="0.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </span>
                        </div>
                        <div class="file-label" [class.attached]="drawingFiles.length > 0">
                            <strong>Drawing File</strong>
                            <span *ngIf="drawingFiles.length > 0" class="file-check">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
                                    fill="none">
                                    <path
                                        d="M9.55237 2.97725C9.76915 2.75758 10.1206 2.75758 10.3374 2.97725C10.5515 3.19423 10.5542 3.54436 10.3453 3.7646L5.91018 9.0073C5.90592 9.0127 5.90136 9.01786 5.89654 9.02275C5.67975 9.24242 5.32828 9.24242 5.11149 9.02275L2.41259 6.28791C2.1958 6.06824 2.1958 5.71209 2.41259 5.49242C2.62937 5.27275 2.98085 5.27275 3.19763 5.49242L5.48729 7.81256L9.53764 2.99408C9.54222 2.98818 9.54713 2.98256 9.55237 2.97725Z"
                                        fill="#0A0F15" />
                                </svg>
                            </span>
                            <span *ngIf="drawingFiles.length === 0" class="file-x">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9"
                                    fill="none">
                                    <path
                                        d="M1.20738 1.60512C1.09754 1.49529 1.09754 1.31721 1.20738 1.20738C1.31721 1.09754 1.49529 1.09754 1.60512 1.20738L4.5 4.10225L7.39488 1.20738C7.50471 1.09754 7.68279 1.09754 7.79262 1.20738C7.90246 1.31721 7.90246 1.49529 7.79262 1.60512L4.89775 4.5L7.79262 7.39488C7.90246 7.50471 7.90246 7.68279 7.79262 7.79262C7.68279 7.90246 7.50471 7.90246 7.39488 7.79262L4.5 4.89775L1.60512 7.79262C1.49529 7.90246 1.31721 7.90246 1.20738 7.79262C1.09754 7.68279 1.09754 7.50471 1.20738 7.39488L4.10225 4.5L1.20738 1.60512Z"
                                        fill="#0A0F15" stroke="#0A0F15" stroke-width="0.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="edit-button">
                <button type="button" class="btn-edit" (click)="onEditPart(partForm.get('rfqPartId')?.value)">
                    <img src="assets/img/svg/pencil-white.svg" alt="Edit">
                </button>
            </div>
        </div>
    </div>

    <!-- Continue Button -->
    <div class="continue-section" *ngIf="!showEditPartSection">
        <button class="btn-continue" (click)="onReviewSummaryClick()">Review RFQ Summary</button>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="addPartModal" data-bs-keyboard="false" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button class="close-btn" data-bs-dismiss="modal" (click)="backCloseFileUploadModel()">
                    <img src="assets/img/svg/close-x-lg.svg" alt="Close">
                </button>
            </div>
            <div class="modal-body" [formGroup]="partForm">
                <!-- 3D Model File Upload -->
                <div class="upload-section">
                    <h2>Upload Your Files</h2>
                    <div class="d-flex gap-2">
                        <h3>UPLOAD 3D MODEL FILE </h3>
                        <div class="tooltip-container">
                            <img src="assets/img/svg/tooltip-icon.png" alt="Tooltip" class="tooltip-icon">
                            <div class="tooltip-popup">
                                Why Upload 3D Files? Adding a 3D model can help suppliers better understand your part.
                            </div>
                        </div>
                    </div>
                    <p class="file-types">Model files: .step, .stp, .stl, .igs, .iges, .x_t, .x_b, .sldprt, .3mf</p>

                    <!-- Drop Area -->
                    <div class="drop-area" (dragover)="onDragOver($event)" (drop)="onModelFileDropped($event)">
                        <p>Drag and drop a file here or</p>
                        <input type="file" #modelFileInput id="modelFileInput" style="display: none"
                            (change)="onModelFileSelected($event)"
                            accept=".step,.stp,.stl,.igs,.iges,.x_t,.x_b,.sldprt,.3mf" multiple>
                        <button class="upload-btn" (click)="modelFileInput.click()">Click to upload</button>
                    </div>

                    <!-- Error Message -->
                    <div *ngIf="modelFileError" class="error-message">
                        {{ modelFileError }}
                    </div>

                    <!-- Uploaded Files List -->
                    <div *ngIf="modelFiles.length > 0" class="uploaded-files">
                        <!-- File Items -->
                        <div *ngFor="let file of modelFiles; let i = index" class="file-item">
                            <span>{{ formatFileName(file.name) }}</span>
                            <button class="delete-btn" (click)="removeModelFile(i)">
                                <img src="assets/img/svg/delete-icon.svg" alt="Delete">
                            </button>
                        </div>
                    </div>
                </div>

                <!-- 2D Drawing File Upload -->
                <div class="upload-section">
                    <div class="d-flex gap-2">
                        <h3>UPLOAD 2D DRAWING FILE</h3>
                        <div class="tooltip-container">
                            <img src="assets/img/svg/tooltip-icon.png" alt="Tooltip" class="tooltip-icon">
                            <div class="tooltip-popup">
                                Why Upload 2D Files? RFQs with a 2D file get 31% more quotes within 48 hours! Attach a
                                detailed 2D drawing specifying material grades, tolerances, and surface finishes to
                                improve quote accuracy.
                            </div>
                        </div>
                    </div>
                    <p class="file-types">Drawing files: .pdf, .dwg, .dxf, .slddrw, .png, .jpg, .bmp, .tif</p>

                    <!-- Drop Area -->
                    <div class="drop-area" (dragover)="onDragOver($event)" (drop)="onDrawingFileDropped($event)">
                        <p>Drag and drop a file here or</p>
                        <input type="file" #drawingFileInput id="drawingFileInput" style="display: none"
                            (change)="onDrawingFileSelected($event)"
                            accept=".pdf,.dwg,.dxf,.slddrw,.png,.jpg,.bmp,.tif">
                        <button class="upload-btn" (click)="drawingFileInput.click()">Click to upload</button>
                    </div>

                    <!-- Error Message -->
                    <div *ngIf="fileError" class="error-message">
                        {{ fileError }}
                    </div>

                    <!-- Uploaded Files List -->
                    <div *ngIf="drawingFiles.length > 0" class="uploaded-files">
                        <!-- File Items -->
                        <div *ngFor="let file of drawingFiles; let i = index" class="file-item">
                            <span>{{ formatFileName(file.name) }}</span>
                            <button class="delete-btn" (click)="removeDrawingFile(i)">
                                <img src="assets/img/svg/delete-icon.svg" alt="Delete">
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn-back" data-bs-dismiss="modal" (click)="backCloseFileUploadModel()">Back</button>
                <button class="btn-continue-dark" (click)="onContinueClick()"
                    [disabled]="modelFiles.length === 0 && drawingFiles.length === 0" data-bs-dismiss="modal">
                    Continue
                </button>
            </div>
        </div>
    </div>
</div>